// extracted by mini-css-extract-plugin
export var active = "Lists-module--active--94fd7";
export var circle = "Lists-module--circle--26497";
export var content = "Lists-module--content--2faaf";
export var list = "Lists-module--list--802c3";
export var sliderCircleContent = "Lists-module--sliderCircleContent--c65d1";
export var touchStart = "Lists-module--touchStart--1c85b";